/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import KeyprIcon from '@keypr/icon-font';
import { RaisedButton } from 'material-ui';
import LeftIcon from 'material-ui/svg-icons/navigation/chevron-left';
import moment from 'moment/moment';
import actions from '../../state/actions';
import Channel from '../../components/Channel';
import Severity from '../../components/Severity';
import Screen from '../../components/Screen';
import DeliveryTime from '../../components/Filters/DeliveryTime';
import AffiliateTime from '../../components/Filters/AffiliateTime';
import { PageLoader } from '../../components/PageWrapper';
import formUtils from '../../utils/forms';
import { serviceRequests as statusOptions } from '../../config/service-options';
import Select from '../../components/Select';
import StaffAvailability from '../../containers/StaffAvailability';
import RoomService from '../../components/FormConfigs/RoomService';
import { LocationType, HistoryType, MatchType } from '../../types/router';
import { RequestType, ServiceConfigType, ChannelType } from './types';
import { populate } from './RequestDetailState';
import { localize, t } from '../../i18n';
import Tab from '../../components/Tab';
import AddAttachment from '../../containers/AddAttachment';
import SortPills from '../../components/SortPills';
import Comment from '../../components/Comment';

import './RequestDetail.css';

class RequestDetail extends Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;

    const {
      location: {
        state: {
          tab: activeTab = 'details',
        } = {},
      },
    } = this.props;

    this.state = {
      activeTab,
      sortComments: 'desc',
      status: null,
      assigned: null,
      form: {},
      formUpdated: false,
    };
  }

  componentWillMount() {
    const {
      location: {
        state = {},
      },
      match: {
        params: {
          requestId,
        },
      },
      processResourceRequest,
      affiliateConfig,
    } = this.props;


    processResourceRequest(requestId, state, affiliateConfig);
  }

  componentWillReceiveProps(nextProps) {
    const { request } = nextProps;
    if (request && (this.props.request !== request)) {
      this.setState({
        status: request.status,
        assigned: request.assigned,
      });
    }

    if (this.state.status === null && nextProps.actionType === 'API_READ' && nextProps.request) {
      this.setState({
        status: nextProps.request.status,
        assigned: nextProps.request.assigned,
      });
    }
  }

  handleChange(value, name) {
    let status = this.state.status;
    let assigned = this.state.assigned;
    let formUpdated = true;
    const newFormValues = Object.assign({}, this.state.form);
    newFormValues[name] = value;
    if (name === 'status') {
      status = value;
      if (this.props.staffList.length === 0) {
        formUpdated = false;
      }
    }
    if (name === 'assigned') {
      assigned = value;
      const assignee = _.find(this.props.staffList, { id: value });
      const assigneeName = `${assignee.first_name} ${assignee.last_name}`;
      newFormValues.assignee_name = assigneeName;
    }
    this.setState({
      assigned,
      status,
      form: newFormValues,
      formUpdated,
    });
  }

  goBackToList() {
    this.props.history.push('/access/requests');
  }

  handleUpdateRequest() {
    const {
      updateRequest,
      request: {
        _id: requestId,
      },
    } = this.props;

    updateRequest(requestId, this.state.form).then(() => this.goBackToList());
  }

  handleResourceViewChange(activeTab) {
    this.setState({ activeTab });
  }

  handleAddAttachments(attachments) {
    const {
      request,
    } = this.props;

    const comment = {
      text: attachments.description,
    };

    this.setState({
      tempComment: comment,
    }, () => {
      this.props.createRequestComment(request._id, comment);
    });
  }

  sortComments(comments, direction) {
    let sortedComments = _.sortBy(comments, item => moment(item._created).toDate().getTime());

    if (direction === 'desc') {
      sortedComments = sortedComments.reverse();
    }

    return sortedComments;
  }

  renderServiceRequest() {
    const {
      activeTab,
      sortComments,
    } = this.state;

    const {
      request,
      serviceConfig,
      channel,
      staffList,
      menuRestaurants,
      affiliateConfig,
      requestComments,
    } = this.props;

    request.dashboardColor = channel.dashboard_color;
    request.icon = serviceConfig.service_icon;

    const backgroundColorChart = {
      warning: 'md-card-bg-warning',
      critical: 'md-card-bg-danger',
    };
    const detailsCardCls = ['md-card'];
    if (_.has(backgroundColorChart, request.severity)) {
      detailsCardCls.push(backgroundColorChart[request.severity]);
    } else {
      detailsCardCls.push('md-card-bg-success');
    }

    let messageFieldDisabled = false;
    if (['new', 'acknowledged', 'assigned'].indexOf(this.state.status) !== -1) {
      messageFieldDisabled = true;
    }

    const assigneesOptions = _.map(staffList, staff => ({
      value: staff.id,
      label: (
        <div className="staff">
          <StaffAvailability userId={staff.id} isAvailable={staff.is_available} />
          <span>
            {staff.first_name} {staff.last_name}
          </span>
        </div>
      ),
    }));

    const submitButtonDisabled = this.state.formUpdated === false;
    const salesTaxEnabled = _.get(affiliateConfig, 'sales_tax') === 'true';
    const sortedRequestComments = this.sortComments(requestComments, sortComments);

    const requestDetailInfo = (
      <div className="form-detail">
        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Type')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            <span className="menu_icon"><KeyprIcon icon={request.icon} className="service-icon" /></span>
            {request.label}
          </div>
        </div>
        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Room')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {request.room}
          </div>
        </div>
        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Guest')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {request.guest_name}
          </div>
        </div>

        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Due Time')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            <DeliveryTime epochs={request.epochs} expanded />
          </div>
        </div>
        {(['room_service', 'upsell'].indexOf(request.type) !== -1) ? (
          <RoomService body={request.body} configs={menuRestaurants} salesTaxEnabled={salesTaxEnabled} />
        ) : (
          formUtils.getFormItems({
            body: request.body,
            type: request.type,
            configs: [serviceConfig],
            title: 'service_name',
          })
        )}
        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Submitted')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            <AffiliateTime time={request._created} mask="hh:mm A MM/DD/YY" />
          </div>
        </div>

        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Status')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            <Select
              name="form-field-status"
              value={this.state.status}
              options={
                statusOptions.map(o => (
                  {
                    ...o,
                    label: this.props.t(o.label),
                  }
                ))
              }
              onChange={evt => this.handleChange(evt, 'status')}
              clearable={false}
              openAfterFocus
            />
          </div>
        </div>
        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Assigned To')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {(assigneesOptions.length > 0) ? (
              <Select
                name="form-field-assigned"
                value={this.state.assigned}
                options={assigneesOptions}
                onChange={value => this.handleChange(value, 'assigned')}
                clearable={false}
                openAfterFocus
              />
            ) : (
              <span className="uk-text-muted uk-text-italic">{this.props.t('No staff assigned.')}</span>
            )}
          </div>
        </div>
        <div className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Message')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {(messageFieldDisabled === true) ? (
              <span className="uk-text-muted uk-text-italic">
                {this.props.t('Messages can not be added to service requests with a status of {status}', { status: this.props.t((_.find(statusOptions, { value: this.state.status }) || {}).label || 'Unknown') })}
              </span>
            ) : (
              <textarea
                cols="18" rows="4"
                className="md-input"
                defaultValue={request.user_comment}
                onChange={evt => this.handleChange(evt.target.value, 'user_comment')}
              />
              )}
          </div>
        </div>
      </div>
    );

    const commentList = sortedRequestComments.map((comment, idx) => (
      <Comment
        key={`comment-${idx}`}
        comment={comment}
        addModalControl
        onShowModal={(setModalInfo) => {
          this.setState({
            showCommentModal: true,
            modalInfo: setModalInfo,
          });
        }}
      />
    ));

    const comments = (
      <ul className="md-list">
        {commentList}
      </ul>
    );

    const requestCommentsInfo = (
      <div>
        <span className="uk-text-danger">{this.props.t('Important: Comments entered below will be sent to guest devices')}</span>
        <AddAttachment
          itemId={request._id}
          onAddAttachments={attachments => this.handleAddAttachments(attachments)}
          className="md-card-content-fab-spacer"
          hintText={this.props.t('Add new comment')}
          addDescription
          blockNativeOverride
        />
        <h3 className="heading_b">{this.props.t('Comments List')}</h3>
        <SortPills
          activeOption={sortComments}
          options={[
            { value: 'asc', label: this.props.t('Ascending') },
            { value: 'desc', label: this.props.t('Descending') },
          ]}
          onChange={(changeSortComments) => {
            this.setState({
              sortComments: changeSortComments,
            });
          }}
        />
        {comments}
      </div>
    );

    const commentsLabel = t('Comments');

    const AVAILABLE_TABS = [
      { tab: 'details', label: t('Details') },
      { tab: 'comments', label: `${commentsLabel} (${requestComments.length})` },
    ];

    return (
      <div id={request._id} className={detailsCardCls.join(' ')}>
        <div className="md-card-toolbar">
          <div className="md-card-toolbar-actions">
            <Channel channel={request.channel} color={request.dashboardColor} />
          </div>
          <h3 className="md-card-toolbar-heading-text">
            <Severity severity={request.severity.toString()} />
          </h3>
        </div>

        <div className="md-card-content">
          <Tab
            tabs={AVAILABLE_TABS}
            activeTab={activeTab}
            onChange={(tab) => {
              this.handleResourceViewChange(tab);
            }}
            content={{
              details: requestDetailInfo,
              comments: requestCommentsInfo,
            }}
          />
        </div>
        <div className="md-card-footer uk-text-right">
          <RaisedButton
            icon={<LeftIcon />}
            label={this.props.t('back')}
            onClick={() => this.goBackToList()}
          />

          {activeTab === 'details' ? (<RaisedButton
            label={this.props.t('Submit')}
            style={{ marginLeft: '1em' }}
            primary
            disabled={submitButtonDisabled}
            onClick={() => this.handleUpdateRequest()}
          />) : null}
        </div>
      </div>
    );
  }

  render() {
    const { isLoading } = this.props;

    return (
      <Screen title={this.props.t('Requests')} helpUrl="#sr">
        <div className="RequestDetail">
          {isLoading ? (
            <PageLoader circular withHeader />
          ) :
            (
              <div className="uk-grid uk-flex-center">
                <div className="uk-width-small-4-5 uk-width-mobile-1-1">
                  {this.renderServiceRequest()}
                </div>
              </div>
            )}
        </div>
      </Screen>
    );
  }
}

RequestDetail.propTypes = {
  /* eslint-disable */
  actionType: PropTypes.string,
  activeTab: PropTypes.string,
  sortComments: PropTypes.string,
  /* eslint-enable */

  location: LocationType,
  history: HistoryType,
  match: MatchType,
  updateRequest: PropTypes.func,
  processResourceRequest: PropTypes.func,

  request: RequestType,
  serviceConfig: ServiceConfigType,
  channel: ChannelType,
  isLoading: PropTypes.bool,

  requestComments: PropTypes.arrayOf(PropTypes.object),
  staffList: PropTypes.arrayOf(PropTypes.object),
  menuRestaurants: PropTypes.arrayOf(PropTypes.any),
  createRequestComment: PropTypes.func,
  affiliateConfig: PropTypes.shape({
    sales_tax: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let menuRestaurants = [];
  let requestComments = [];

  const {
    session: {
      affiliate,
    },
    views: {
      requestDetail,
    },
  } = state;

  const {
    match: {
      params: {
        requestId,
      },
    },
  } = ownProps;

  const actionType = state.action.type;

  if (state.menu.menucache) {
    menuRestaurants = state.menu.menucache._items;
  }

  if (state.ticket.service_comment) {
    requestComments = _.filter(state.ticket.service_comment._items, { service_id: requestId });
  }

  const affiliateConfig = _.get(affiliate, 'attributes.config');

  return {
    ...requestDetail,
    affiliateConfig,
    actionType,
    menuRestaurants,
    requestComments,
  };
};

const mapDispatchToProps = dispatch => ({
  processResourceRequest(requestId, state, affiliateConfig) {
    dispatch(populate(requestId, state));

    // Special case for ICS requests.
    if (affiliateConfig.ics_affiliate === 'false' && (['room_service', 'upsell'].indexOf(state.request.type) !== -1)) {
      // Retrieve menus only for KCS affiliates room_service/upsell requests
      dispatch(actions.retrieveMenusRestaurants());
    }
    dispatch(actions.retrieveRequestComments(requestId));
  },
  updateRequest(requestId, form) {
    return dispatch(actions.updateRequest(requestId, form));
  },
  createRequestComment(requestId, payload) {
    const refreshData = true;
    dispatch(actions.createRequestComment(requestId, payload, refreshData));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(RequestDetail));



// WEBPACK FOOTER //
// ./src/views/requests/RequestDetail.js